import { mapState } from "vuex";
import baseNotificationsService from "@/scripts/notifications/baseNotificationsService";

// Component
import Transaction from "@/views/component/Notifications/Transaction";
import ShutdownImage from "@/views/component/Notifications/ShutdownImage";
import FixedRentalBilling from "@/views/component/Notifications/FixedRentalBilling";
import MachineIsRunning from "@/views/component/Notifications/MachineIsRunning";

export default {
  components: {
    Transaction,
    ShutdownImage,
    FixedRentalBilling,
    MachineIsRunning,
  },

  extends: baseNotificationsService,

  data() {
    return {
      refreshKey: 0,
      isShowList: false,
      contexMenuActionList: {
        markAllRead: 1,
        notificationsSettings: 2,
        openNotifications: 3,
      },
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },

  watch: {
    user: function(newVal, oldVal) {
      if (newVal.notificationsCount > 0) {
        if (this.notificationsCount) {
          if (newVal.notificationsCount > this.notificationsCount) {
            this.notificationsCount = newVal.notificationsCount;
          }
        } else {
          this.notificationsCount = newVal.notificationsCount;
        }
      } else {
        this.notificationsCount = null;
      }
    },
    isShowList(val) {
      if (val) {
        this.getData();
      }
    },
  },

  created() {},

  mounted() {
    this.$root.$on("bv::popover::show", (bvEventObj) => {
      this.getData();
    });

    this.$root.$on("bv::popover::hide", (bvEventObj) => {});
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      this.isShowList = false;
    },
    //#region Processing event
    processingEvent(param) {
      this[param.event](param.data);
    },
    //#endregion

    processingNotification() {
      this.refreshKey += 1;
    },

    //#region Context menu action
    contextMenuAction(command) {
      switch (command) {
        case this.contexMenuActionList.markAllRead:
          this.markAllRead();
          break;
        case this.contexMenuActionList.notificationsSettings:
          this.pushUrl({ name: "user", params: { userId: "123" } });
          break;
        case this.contexMenuActionList.openNotifications:
          break;
      }
    },
    //#endregion
  },
};
